(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["preorder-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('preorder-timeline')) {
    customElements.define(
      'preorder-timeline',
      class extends HTMLElement {
        connectedCallback() {
          if (this.classList.contains('is-in')) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || !('IntersectionObserver' in window)) {
            this.classList.add('is-in');
            return;
          }
          this._io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.classList.add('is-in');
                this._io.disconnect();
              }
            },
            { threshold: 0.4 }
          );
          this._io.observe(this);
        }
        disconnectedCallback() {
          if (this._io) this._io.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
